if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      this.cartNotification.setActiveElement(document.activeElement);

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      
      let body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });
     
      const form = JSON.parse(serializeForm(this.form).replace("options[Length]", "length"));

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          this.cartNotification.renderContents(parsedState);
          
          if (window.cartSettings.drawerCartEnabled === 'true') {

            // added for minicart
            document.querySelector('cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0);
            document.getElementById('main-cart-items')?.classList.toggle('is-empty', parsedState.item_count === 0); document.getElementById('main-cart-footer')?.classList.toggle('is-empty', parsedState.item_count === 0);

            ToggleCart(true);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  });
}

// Colour 2 - on hover, display text value under swatch

 document.addEventListener('DOMContentLoaded', function () {
  const colorLabels = document.querySelectorAll('label[data-color-value]');
  const hoverText = document.getElementById('color-hover-text');

  colorLabels.forEach(label => {
    label.addEventListener('mouseenter', function () {
      hoverText.textContent = this.getAttribute('data-color-value');
    });

    label.addEventListener('mouseleave', function () {
      // Keep the text as the selected input value if exists
      const selectedInput = document.querySelector('input[name="Colour 2"]:checked');
      if (selectedInput) {
        hoverText.textContent = selectedInput.value;
      } else {
        hoverText.textContent = '';
      }
    });

    label.addEventListener('click', function () {
      hoverText.textContent = this.getAttribute('data-color-value');
    });
  });

  // Ensure the selected value is displayed on load
  const selectedInput = document.querySelector('input[name="Colour 2"]:checked');
  if (selectedInput) {
    hoverText.textContent = selectedInput.value;
  }
});

